import {LocalDateTime} from 'js-joda'
import {
    andThen,
    Decoder,
    fail,
    field,
    number,
    object,
    string,
    succeed
} from 'json-bouncer'
import {localDateTimeDecoder} from '../Data/DecodeHelper'

export interface OrderProtocol {
    readonly id: number
    readonly orderId: number
    readonly action: 'InvoiceSent'
    readonly cis2UserId: number
    readonly at: LocalDateTime
}

export function orderProtocolDecoder(): Decoder<OrderProtocol> {
    return object({
        id: field('id', number()),
        orderId: field('orderId', number()),
        action: field('action', orderProtocolActionDecoder()),
        cis2UserId: field('ppUserId', number()),
        at: field('at', localDateTimeDecoder()),
    })
}

export type OrderProtocolAction = 'InvoiceSent'

export function orderProtocolActionDecoder(): Decoder<OrderProtocolAction> {
    const invoiceSent: OrderProtocolAction = 'InvoiceSent'
    return andThen(
        value => value === 'InvoiceSent' ?
            succeed(invoiceSent) :
            fail('Must be InvoiceSent'),
        string())
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/OrderProtocol.ts